"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _q = _interopRequireDefault(require("q"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _CTAApiClient = require("AudienceTargetingUIComponents/api/CTAApiClient");

var _FormsApiClient = require("AudienceTargetingUIComponents/api/FormsApiClient");

var CTA_CLICKS_FILTER_TYPE = 'CTA_CLICKS';
var FORM_VIEW_FILTER_TYPE = 'FORM_VIEW';

var FilterMultiSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterMultiSelect, _PureComponent);
  (0, _createClass2.default)(FilterMultiSelect, null, [{
    key: "propTypes",
    get: function get() {
      return {
        labelConfig: _react.PropTypes.object,
        options: _react.PropTypes.array,
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        placeholder: _react.PropTypes.string,
        type: _react.PropTypes.string,
        value: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_immutable.List), _react.PropTypes.array, _react.PropTypes.string])
      };
    }
  }]);

  function FilterMultiSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterMultiSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterMultiSelect).call(this, props));
    _this.state = {
      options: [],
      noResults: false,
      hasMissingAsset: false,
      input: '',
      isInputValid: true
    };
    return _this;
  }

  (0, _createClass2.default)(FilterMultiSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          type = _this$props.type,
          value = _this$props.value;
      var isCTA = type === CTA_CLICKS_FILTER_TYPE;
      var fetchAsset = isCTA ? _CTAApiClient.fetchCTA : _FormsApiClient.fetchForm;
      var normalizedValue = value && _immutable.List.isList(value) ? value.toJS() : value;
      var missingKey = isCTA ? 'missingCTA' : 'missingForm';

      var missingText = labelConfig[missingKey] || _I18n.default.text(this.getLangKey(missingKey));

      var hasMissingAsset = this.state.hasMissingAsset;
      if (!normalizedValue) return;

      _q.default.Promise.all(normalizedValue.map(function (val) {
        return fetchAsset(val).catch(function () {});
      })).then(function (results) {
        var normalizedResults = isCTA ? results : results.map(function (result) {
          return result ? result.form : result;
        });

        if (results) {
          var options = normalizedResults.map(function (result, idx) {
            if (result) {
              return {
                text: result.name,
                value: result.guid
              };
            } else {
              hasMissingAsset = true;
              return {
                text: missingText,
                value: normalizedValue[idx],
                tagUse: 'error'
              };
            }
          }).concat(_this2.state.options);

          _this2.setState({
            options: options,
            hasMissingAsset: hasMissingAsset
          });
        }
      }).done();
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var _this3 = this;

      var _this$props2 = this.props,
          labelConfig = _this$props2.labelConfig,
          placeholder = _this$props2.placeholder,
          value = _this$props2.value,
          options = _this$props2.options,
          _onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange,
          type = _this$props2.type;
      var fetchList = type === CTA_CLICKS_FILTER_TYPE ? _CTAApiClient.fetchCTAList : _FormsApiClient.fetchFormsList;
      var disabledKey = type === CTA_CLICKS_FILTER_TYPE ? 'noCtas' : 'noForms';

      var disabledText = labelConfig[disabledKey] || _I18n.default.text(this.getLangKey(disabledKey));

      var normalizedValue = value && value.toJS ? value.toJS() : value;

      if (type === CTA_CLICKS_FILTER_TYPE || type === FORM_VIEW_FILTER_TYPE) {
        return _react.default.createElement(_UITooltip.default, {
          title: disabledText,
          disabled: !this.state.noResults
        }, _react.default.createElement("div", null, _react.default.createElement(_UISelect.default, {
          disabled: this.state.noResults,
          error: !this.state.isInputValid,
          multiCollapseLimit: 4,
          options: this.state.options,
          onSelectedOptionChange: function onSelectedOptionChange(e) {
            var isCTA = type === CTA_CLICKS_FILTER_TYPE;
            var values = e.target.value;
            var missingKey = isCTA ? 'missingCTA' : 'missingForm';

            var missingText = labelConfig[missingKey] || _I18n.default.text(_this3.getLangKey(missingKey));

            var missingValues;

            if (_this3.state.hasMissingAsset) {
              missingValues = values.filter(function (val) {
                return val.text === missingText;
              });

              if (!missingValues.length) {
                _this3.setState({
                  hasMissingAsset: false
                });
              }
            }

            _this3.setState({
              isInputValid: Boolean(values.length)
            });
          },
          loadOptions: function loadOptions(input, callback) {
            var pagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
              offset: 0
            };
            var length = pagination.length;
            var offset = pagination.offset;
            var requestSize = length && length > offset + 10 ? 10 : length - offset;
            var pageSize = !isNaN(requestSize) ? requestSize : 10;
            var nextOffset = pagination.offset + pageSize;

            if (offset === length) {
              callback(null, {
                options: _this3.state.options,
                pagination: {
                  hasMore: false,
                  length: length,
                  offset: nextOffset
                }
              });
              return;
            }

            fetchList(offset, pageSize, input).then(function (result) {
              var itemsName = type === CTA_CLICKS_FILTER_TYPE ? 'results' : 'dashboardItems';
              var countName = type === CTA_CLICKS_FILTER_TYPE ? 'total' : 'totalFormsCount';
              var count = result[countName];
              var items = [];
              var hasSearch = _this3.state.input !== input;

              if (result[itemsName]) {
                items = result[itemsName].map(function (item) {
                  return {
                    text: item.name,
                    value: item.guid
                  };
                });
              }

              if (!count && !input) {
                _this3.setState({
                  noResults: true
                });
              }

              _this3.setState({
                options: hasSearch ? items : _this3.state.options.concat(items),
                input: input
              }, function () {
                callback(null, {
                  options: _this3.state.options,
                  pagination: {
                    hasMore: count > nextOffset,
                    length: count,
                    offset: nextOffset
                  }
                });
              });
            });
          },
          multi: true,
          onBlur: function onBlur(e) {
            _onBlur(e);

            _this3.setState({
              isInputValid: Boolean(normalizedValue.length)
            });
          },
          onChange: onChange,
          placeholder: placeholder,
          value: normalizedValue
        })));
      } else {
        return _react.default.createElement(_UISelect.default, {
          error: !this.state.isInputValid,
          multi: true,
          allowCreate: true,
          placeholder: placeholder,
          value: value,
          options: options,
          onChange: onChange
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input long"
      }, this.renderSelect());
    }
  }]);
  return FilterMultiSelect;
}(_react.PureComponent);

exports.default = FilterMultiSelect;
module.exports = exports.default;